var render = function render(_c,_vm){return _c('i',{class:_vm.props.addClass,domProps:{"innerHTML":_vm._s(require(`!!html-loader!@customer/assets/svg/icons/${_vm.props.name}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }